import React, { useCallback } from 'react';
import { useDateURLFormatter, useTimeFormatter } from '../../../../../../data/hooks/datetimeHooks';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useMeetings } from '../../../../../../data/hooks/meeting/useMeetings';
import { dialogConfirm } from '../../../../../elements/Dialog/dialogs';
import EventTimezone from '../../../../../elements/EventTimezone/EventTimezone';
import Grid from '../../../../../elements/Grid';
import TimeInterval from '../../../../../elements/TimeInterval/TimeInterval';
import Slot from '../../../../../elements/TimeslotSelection/Slot';
import { useUnblockSlotCallback } from './useUnblockSlotCallback';
import styles from './SlotSelectionGrid.module.scss';
import { useSelectSlotCallback } from './useSelectSlotCallback';

function SlotSelectionGrid(props) {
    const { event, slot: selectedSlot, slots = [], onChange } = props,
        formatTime = useTimeFormatter(),
        i18n = useI18n(),
        handleSelectSlot = useSelectSlotCallback(event, onChange)

    return (
        <>
            <EventTimezone className={styles.timezone} event={event} />
            <Grid columns={4}>
                {slots.map((slot) => (
                    <Slot selected={slot === selectedSlot} slot={slot} key={[slot.start, slot.end].join()} onClick={() => handleSelectSlot(slot)} formatTime={formatTime} locationRequired />
                ))}
            </Grid>
        </>
    );
}

export default SlotSelectionGrid;
